export const standardReturnDays = 14;
